import React from "react";
import ClearIcon from '@mui/icons-material/Clear';
import Button from "./Button";

const DialogHeaderWithClose = ({ classicClass, posModalNameClassic, text, handleClose, style, noBackground, noCancel }) => {
  const filterText = text && text.length > 90 ? text.substring(0, 90) + "..." : text || ``;

  return (
    <div className="DialogHeaderWithClose">
      {style === "pink" ? 
        <div className="modal-title">
          {filterText}
          {!noCancel && <Button
            name="close"
            type="IconButton"
            className="corner_XX"
            primary={false}
            onTouchTap={handleClose} 
            icon={<ClearIcon/>}  
          />}
        </div>
      : <div className={`${!noBackground ? `chartHeaderBar` : `chartHeaderBarNoBg`} ${classicClass || ``}`}>
        <div
          className={`chartbgColor ${classicClass || ``} ${posModalNameClassic || ``}`}
        >
          <span className={`whiteFontColor`}>{filterText}</span>
          <div className='bg-svg'>
            <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              className={`bg-svg`}
            >
              <rect className="sideZero" width="40" height="40" />
              <path
                className="sideOne"
                d="M0,0v40h1.45L26.44,6.73C29.55,2.65,34.87,0,40,0H0z"
              />
            </svg>
          </div>
        </div>
        {!noCancel && <Button
          name="close"
          type="IconButton"
          className="corner_XX"
          primary={false}
          onTouchTap={handleClose} 
          icon={<ClearIcon/>}  
        />}
      </div>}
    </div>
  );
}

export default DialogHeaderWithClose;
